import Util from 'root/module/util';
import Cache from 'root/cache';
import View from 'view/base';

export default View.extend({
    className: 'survey-question-overview box',

    is_loaded: false,

    limit: 5,

    events: {
        'click .show-all': 'onShowAll'
    },

    dom_handlers: {
        onShowAll: function(e) {
            e.preventDefault();
            this.limit = 10;
            this.render();
        }
    },

    event_handlers: {
        onDateChange: function(date_frame) {
            this.date_frame = date_frame;

            this.load();
        }
    },

    initialize: function(options) {
        this.date_frame = options.date_frame || 'all';
        Cache.app.dispatcher.on('Overview::Date_Change', this.event_handlers.onDateChange.bind(this));
    },

    load: function() {
        Cache.app.request({
            action: 'survey_question/overview',
            data: {
                question_id : this.model.id,
                date_frame  : this.date_frame
            },
            cache: 120, // cache 120 seconds
            success: (response) => {
                this.is_loaded = true;
                this.data = response;
                this.$el.find('.question-chart').html(this.renderChart());
            }
        });
    },

    renderText: function() {
        var options = this.data.options;

        var options_html = '';
        var hidden_options_html = '';

        if (options && options.length) {
            options.forEach((option, i) => {
                if (i < this.limit) {
                    options_html +=
                    '<div class="option">' +
                        '<div class="answer">' + Util.htmlEntities(Util.trim(option.text, 200)) + '</div>' +
                        '<div class="date">' + Util.moment(option.timestamp, 'DD MMM YYYY h:mm a', false, false) + '</div>' +
                    '</div>';
                } else {
                    hidden_options_html +=
                    '<div class="option">' +
                        '<div class="answer">' + Util.htmlEntities(Util.trim(option.text, 200)) + '</div>' +
                        '<div class="date">' + Util.moment(option.timestamp, 'DD MMM YYYY h:mm a', false, false) + '</div>' +
                    '</div>';
                }
            });
        }

        hidden_options_html = hidden_options_html ? '<div class="hidden-options">' + hidden_options_html + '</div>' : '';

        var show_all_html = '';
        if (options && options.length) {
            if (this.limit < options.length) {
                if (this.limit === 10) {
                    show_all_html = '<a href="/' + Cache.getDefaultProject().get('project_key') + '/response/" class="view-all-responses primary">View all responses</a>';
                } else {
                    show_all_html = '<a href="#" class="show-all primary">Show all answers</a>';
                }
            }
        }

        var html =
        '<div class="percentage-text">' + this.renderAnswerRate(this.data.open, this.data.total) + '</div>' +
        '<div class="chart-text">' + options_html + hidden_options_html +'</div>' +
        show_all_html;

        return html;
    },

    renderRate: function(numerator, denominator, is_rate = false) {
        if (denominator > 0) {
            if (is_rate) {
                return (numerator / denominator).toFixed(2);
            }
            // percentage
            var percentage = numerator * 100 / denominator;
            if (Number.isInteger(percentage)) {
                return percentage;
            }

            return percentage.toFixed(2);
        }

        return '0.00';
    },

    renderAnswerRate: function(open, total) {
        if (total) {
            var percentage = this.renderRate(open, total);
            return open + ' of ' + total + ' answered (<span class="percentage">' + percentage + '%</span>)';
        }

        return '0 of 0 answered (<span class="percentage">0.00%</span>)';
    },

    renderNps: function() {
        var total = this.data.detractors + this.data.passives + this.data.promoters;

        var percentage = total === 0 ? { detractors: 0, passives: 0, promoters: 0 } :
        {
            detractors: this.data.detractors / total * 100,
            passives: this.data.passives / total * 100,
            promoters: this.data.promoters / total * 100
        };

        var html =
        '<div class="percentage-text">' + this.renderAnswerRate(this.data.open, this.data.total) + '</div>' +
        '<div class="question-chart-title">NPS</div>' +
        '<div class="question-chart-score">' +
            this.data.score +
        '</div>' +
        (total > 0 ?
        '<div class="nps-bar">' +
            '<span style="width:' + percentage.detractors + '%;"></span>' +
            '<span style="width:' + percentage.passives + '%;"></span>' +
            '<span style="width:' + percentage.promoters + '%;"></span>' +
        '</div>' +
        '<div class="nps-count">' +
            '<div data-type="detractor">' +
                '<div class="nps-count-title">Detractors</div>' +
                '<div>' + this.data.detractors + ' <span class="text-info">(' + this.renderRate(this.data.detractors, total) + '%)</span></div>' +
            '</div>' +
            '<div data-type="passive">' +
                '<div class="nps-count-title">Passives</div>' +
                '<div>' + this.data.passives + ' <span class="text-info">(' + this.renderRate(this.data.passives, total) + '%)</span></div>' +
            '</div>' +
            '<div data-type="promoter">' +
                '<div class="nps-count-title">Promoters</div>' +
                '<div>' + this.data.promoters + ' <span class="text-info">(' + this.renderRate(this.data.promoters, total) + '%)</span></div>' +
            '</div>' +
        '</div>' : '');

        return html;
    },

    renderRating: function() {
        var bar = [];

        switch (this.model.get('question_sub_type')) {
            case 'thumb':
                bar = [];
                if (this.data.groups && this.data.groups.length) {
                    this.data.groups.forEach((group) => {
                        bar.push({
                            text: group.answer === '1' ? '👍': '👎',
                            size: this.renderRate(group.count, this.data.total) + '%',
                            count: group.count
                        });
                    });
                }

                break;
            default:
                if (this.data.groups && this.data.groups.length) {
                    // sort by answer, and filter out the empty answer
                    this.data.groups = this.data.groups.filter((group) => {
                        return group.answer !== '';
                    }).sort((a, b) => {
                        return a.answer - b.answer;
                    });
                    this.data.groups.forEach((group) => {
                        bar.push({
                            text: group.answer,
                            size: this.renderRate(group.count, this.data.total) + '%',
                            count: group.count
                        });
                    });
                }

                break;
        }

        var bar_html = '';
        bar.forEach((data) => {
            bar_html += '<div class="bar tooltip" style="height:' + data.size + ';" data-title="' + data.count + ' (' + data.size + ')' + '"><span>' + data.text  +'</span></div>';
        });

        var score_html = '';
        var score = this.renderRate(this.data.total_sum, this.data.total, true)
        if (this.model.get('question_sub_type') === 'thumb') {
            var thumbup = [];
            if (this.data.groups && this.data.groups.length) {
                thumbup = this.data.groups.filter((group) => {
                    return group.answer === '1';
                });
            }

            var thumbup_count = thumbup.length ? thumbup[0].count : 0;
            score_html = '<div class="chart-rating-score">' + this.renderRate(thumbup_count, this.data.total) + '%</div>';
        } else {
            score_html = '<div class="chart-rating-score">' + score + '</div>';
        }

        var face = '-';
        if (this.model.get('question_sub_type') === 'face') {
            const faceIcon = {
                1: '<i class="fa-solid fa-face-confounded"></i>',
                2: '<i class="fa-solid fa-face-frown-slight"></i>',
                3: '<i class="fa-solid fa-face-meh"></i>',
                4: '<i class="fa-solid fa-face-smile"></i>',
                5: '<i class="fa-solid fa-face-laugh-squint"></i>'
            };
            face = faceIcon[Math.ceil(score)] || face;
        }

        var html =
        '<div class="percentage-text">' + this.renderAnswerRate(this.data.open, this.data.total) + '</div>' +
        '<div class="question-chart-title">Average</div>' +
        '<div class="question-chart-score">' +
            (this.model.get('question_sub_type') === 'heart' ? '<i class="fa-solid fa-heart"></i>'      : '') +
            (this.model.get('question_sub_type') === 'star'  ? '<i class="fa-solid fa-star-sharp"></i>' : '') +
            (this.model.get('question_sub_type') === 'thumb' ? '👍' : '') +
            (this.model.get('question_sub_type') === 'face'  ? face : '') +
            score_html +
            (['heart', 'star'].indexOf(this.model.get('icon')) === -1 ? '' :
            '<span class="helper">Out of ' + this.model.escape('scale') + '</span>') +
        '</div>' +

        (this.data.open > 0 ?
        '<div class="chart-rating" data-type="' + this.model.get('question_sub_type') + '">' +
            '<div class="axis-y">' +
                '<div>100</div>' +
                '<div>75</div>' +
                '<div>50</div>' +
                '<div>25</div>' +
                '<div>%</div>' +
            '</div>' +
            bar_html +
        '</div>' : '');

        return html;
    },

    renderMultiple: function() {
        var options = '';
        var groups = this.data.groups || [];

        groups.forEach((group) => {
            options +=
            '<div class="grid-10-2">' +
                '<div class="line-height-150 break-word">' + Util.htmlEntities(group.text) + '</div>' +
                '<div class="line-height-150 text-align-right">' + group.count + ' <span class="text-info">(' + this.renderRate(group.count, this.data.total) + '%)</span></div>' +
            '</div>' +
            '<div class="bar">' +
                '<div style="width:' + this.renderRate(group.count, this.data.total) + '%;"></div>' +
            '</div>';
        });

        var html =
        '<div class="percentage-text">' + this.renderAnswerRate(this.data.open, this.data.total) + '</div>' +
        '<div class="chart-multiple">' + options + '</div>';

        return html;
    },

    renderChart: function() {
        switch (this.model.get('question_type')) {
            case 'short':
            case 'long':
                return this.renderText();
            case 'nps':
                return this.renderNps();
            case 'rating':
                return this.renderRating();
            case 'dropdown':
            case 'yesno':
            case 'multiple':
                return this.renderMultiple();
        }
    },

    render: function() {
        var content =
        '<div class="question-icon" data-type="' + this.model.get('question_type') + '"></div>' +
        '<div>' +
            '<div class="question-type">' + this.model.getQuestionType() + '</div>' +
            '<div class="question-label">' + this.model.getLabel(true) + '</div>' +
            '<div class="question-chart" data-type="' + this.model.get('question_type') + '">' +
                (this.is_loaded ? this.renderChart() : '<div class="loader-placeholder-small"></div>') +
            '</div>' +
        '</div>';

        this.$el.html(content);

        if (!this.is_loaded) {
            this.load();
        }

        return this;
    }
});